export function getFileExtension(filename: string): string {
  if (!filename) return '';

  return filename.slice(filename.lastIndexOf('.') + 1).toLowerCase();
}
